import { useQuery } from "@tanstack/react-query";
import { endOfDay } from "date-fns";

import { shipmentDetailListSchema } from "~/features/reports/schemas/shipment-detail-schema.ts";
import { apiRoutes } from "~/shared/services/api/api-routes.ts";
import {
	getAndValidate,
	getAndValidateTraxAr,
} from "~/shared/services/api/fetch-client.ts";
import { getIsInternal } from "~/shared/utils/get-deployment-type.ts";

import type { ShipmentDetail } from "../schemas/shipment-detail-schema.ts";

type UseShipmentDetailsReportParams = {
	customerId: number | undefined;
	startDate: Date | null;
	endDate: Date | null;
	enabled?: boolean;
};

export function useShipmentDetailsReport({
	customerId,
	startDate,
	endDate,
	enabled = true,
}: UseShipmentDetailsReportParams) {
	return useQuery({
		queryKey: ["shipmentDetailsReport", customerId, startDate, endDate],
		queryFn: async (): Promise<ShipmentDetail[]> => {
			const params = new URLSearchParams();

			if (customerId) {
				params.set("CustomerId", String(customerId));
			}
			if (startDate) {
				params.set("StartDate", startDate.toISOString());
			}
			if (endDate) {
				params.set("EndDate", endOfDay(endDate).toISOString());
			}

			const url = `${apiRoutes.SHIPMENTDETAILSREPORT}?${params.toString()}`;
			const fetcher = getIsInternal() ? getAndValidateTraxAr : getAndValidate;
			const result = await fetcher(url, shipmentDetailListSchema);

			if (!result.success) {
				throw new Error(result.error);
			}

			return result.data;
		},
		enabled: !!customerId && !!startDate && !!endDate && enabled,
	});
}
